// src/pages/DownloaderPage/DownloaderPage.jsx

import React, { useState, useMemo, useEffect } from 'react';
import styles from './DownloaderPage.module.css';
import AppCard from '../../components/AppCard/AppCard';
import CategoryTabs from '../../components/CategoryTabs/CategoryTabs';


function DownloaderPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [appsData, setAppsData] = useState([]); 
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);


  
  
  useEffect(() => {
    const fetchApps = async () => {
      try {
        const response = await fetch('/data/apps.json');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setAppsData(data);
      } catch (e) {
        setError('Failed to fetch application data. Please try again later.');
        console.error('Fetching apps failed:', e);
      } finally {
        setLoading(false);
      }
    };

    fetchApps();
  }, []); 


  const categories = useMemo(() => {
    if (loading) return []; 
    const allCategories = new Set(['all']);
    appsData.forEach(app => {
      if (Array.isArray(app.categories)) {
        app.categories.forEach(cat => allCategories.add(cat));
      }
    });

    return Array.from(allCategories)
      .sort((a, b) => {
        if (a === 'all') return -1;
        if (b === 'all') return 1;
        return a.localeCompare(b);
      })
      .map(cat => ({
        value: cat,
        label: cat === 'all' ? 'all' : cat.charAt(0).toUpperCase() + cat.slice(1),
      }));
  }, [appsData, loading]); 

  const filteredApps = useMemo(() => {
    if (loading) return [];
    return appsData.filter(app => {
      const matchesSearch = searchTerm.toLowerCase() === '' ||
                                app.name.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesCategory = selectedCategory === 'all' ||
                                  (Array.isArray(app.categories) && app.categories.includes(selectedCategory));

      return matchesSearch && matchesCategory;
    });
  }, [searchTerm, selectedCategory, appsData, loading]);

  return (
    <main className={`${styles.downloaderPage} container`}>
      <h1 className={styles.title}>Downloads</h1>

      <section className={styles.searchSection}>
        <input
          type="text"
          placeholder="Find an app..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className={styles.searchInput}
          aria-label="App search field"
        />
        <button
          type="button"
          onClick={() => setSearchTerm('')}
          className={styles.clearButton}
          disabled={!searchTerm.trim()}
          aria-label="Clear text in search"
        >
          ×
        </button>
      </section>


      <section className={styles.categoriesSection}>
        {loading ? (
          <p>Loading categories...</p>
        ) : error ? (
          <p className={styles.errorMessage}>{error}</p>
        ) : (
          <CategoryTabs
            categories={categories}
            selectedCategory={selectedCategory}
            onSelectCategory={setSelectedCategory}
          />
        )}
      </section>


      <section className={styles.appGridSection}>
        {loading ? (
          <p>Loading apps...</p>
        ) : error ? (
          <p className={styles.errorMessage}>{error}</p>
        ) : filteredApps.length > 0 ? (
          <div className={styles.appGrid}>
            {filteredApps.map(app => (
              <AppCard key={app.id} app={app} />
            ))}
          </div>
        ) : (
          <p className={styles.noResults}>
            There are no apps that match your search or category.
          </p>
        )}
      </section>
    </main>
  );
}

export default DownloaderPage;